import { Component } from '@angular/core';
import { WHY_INVIERTIS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-value-services',
  templateUrl: './landing-value-services.component.html',
  styleUrls: ['./landing-value-services.component.scss'],
})
export class LandingValueServicesComponent {
  readonly whyInviertis = WHY_INVIERTIS;
}
